import axios from 'axios';

const base = 'mitrol-reportes';

function healthCheck() {
  return axios.get(`${base}/health`);
}

function getReporte(wsParameter, parseResponse) {
  return axios.post(base, { wsParameter, parseResponse });
}

function getAcuAgentes(fechaDesde, fechaHasta) {
  return axios.post(`${base}/acumuladores-agentes`, { fechaDesde, fechaHasta });
}

function getDetalleLlamadas(fechaDesde, fechaHasta) {
  return axios.post(`${base}/detalle-llamadas`, { fechaDesde, fechaHasta });
}

function getReporteGenerico(data) {
  return axios.post(`${base}/generico`, data);
}

function getReporteDesdeUrl(url) {
  return axios.post(`${base}/desde-url`, { url });
}

const MitrolReportesService = {
  healthCheck,
  getReporte,
  getAcuAgentes,
  getDetalleLlamadas,
  getReporteGenerico,
  getReporteDesdeUrl,
};

export default MitrolReportesService;
